import { atom } from 'recoil';

export const isInvoicesFilterModalOpenAtom = atom<boolean>({
  key: 'isInvoicesFilterModalOpenState',
  default: false,
});
